export const TRUE_BLUE = '#0071CC';

export const WINDOWS_BLUE = '#0000a3';
export const WINDOWS_GRAY = '#999999';

export const SUVA_GREY = '#8E8E8E';
